const imageBaseUrl = 'https://res.cloudinary.com/dpabcunnn/image/upload/v1628469170/team';
export const team = [
	{
		name: 'Femi Olayebi',
		image: `${imageBaseUrl}/Femi_m919ko.jpg`,
		title: 'Project Director',
		comment:
			'We have seen the huge potential of the work we do to make long term impact in our society, and are motivated to keep pushing the boundaries.',
	},
	{
		name: 'Sinmi Olayebi',
		image: `${imageBaseUrl}/Sinmi_as9gnd.png`,
		title: 'Monitoring & Evaluation Lead',
		comment:
			'Having to coordinate the many different streams of this dynamic, exciting and impactful project has made a great juggler out of me.',
	},
	{
		name: 'Fadesayo Adebakin',
		image: `${imageBaseUrl}/Fadesayo_gmlg5s.jpg`,
		title: 'Monitoring Support',
		comment: 'Handling the integration and interaction of different components has made me a better tracker of project flow.',
	},
	{
		name: 'Mayowa Odeyemi',
		image: `${imageBaseUrl}/Mayowa_ngnetd.jpg`,
		title: 'Research Lead',
		comment:
			'This project enabled me to make my research knowledge practical and build my capacity to undertake large social impact projects.',
	},
	{
		name: 'Adetoun Ademuyiwa',
		image: `${imageBaseUrl}/Adetoun_atoed4.jpg`,
		title: 'Operations Lead ',
		comment: 'Handling the operations of this project has opened my mind to project management in a broader perspective.',
	},
	{
		name: 'Olumide Akinyemi',
		image: `${imageBaseUrl}/Olumide_hnjcqc.jpg`,
		title: 'Production Manager',
		comment:
			'Managing the production process helped me recognise leadership skills in people and get more tasks completed at the same time.',
	},
	{
		name: 'Yoyin Akindele',
		image: `${imageBaseUrl}/Yoyin_mhstxh.jpg`,
		title: 'Partner Liaison',
		comment:
			'Working on this project has not only pushed me beyond my limits and capabilities, it also helped me be a better Project Manager.',
	},
	{
		name: 'Blessing Akubuo',
		image: `${imageBaseUrl}/Blessing_v6je2q.jpg`,
		title: 'Quality Control Manager',
		comment:
			'I have learnt how to better negotiate for goods and services, and also how to accommodate differences within a diverse team.',
	},
];
